import React from 'react';
import SharedRentalForm from '../admin/SharedRentalForm';

const BACK_TO = '/partner/shared-rentals';
const SUCCESS_TO = '/partner/shared-rentals';

export default function PartnerSharedRentalFormPage(props) {
  return (
    <SharedRentalForm
      {...props}
      backTo={BACK_TO}
      successTo={SUCCESS_TO}
    />
  );
}
